import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LearnerService } from '../../services/learner.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { UserRoleService } from '../../services/user-role.service';
import { JobService } from 'src/app/services//jobs/job.service';
import * as _ from 'lodash';
@Component({
    selector: 'app-info-ncontact',
    templateUrl: './info-ncontact.component.html',
    styleUrls: ['./info-ncontact.component.scss']
})
export class InfoNContactComponent implements OnInit {
    @Input('job') singleJob;
    @Input('learner') learnerObj;
    @Input('jobId') job;
    @Input('assessment') infoNcontactEdit
    @Input('courseComponent') courseComponent;
    @Input('isLayout') layout
    @Input('isLevel3') level3
    infoForm: FormGroup;
    loading: boolean;
    infoEdit: any;
    isLayout = false
    currentJob
    isLevel3 = false
    iscourseName
    userRole = JSON.parse(localStorage.userRoles);
    isReadOnly: boolean = false
    currentUser: any;
    isIQA: boolean = false;
    isTrainer: boolean = false;
    jobData
    user: any;
    isAdmin: boolean = false;
    isLearner: boolean = false;
    constructor(
        public dialog: MatDialog,
        public _snackBar: MatSnackBar,
        public _learnerService: LearnerService,
        public _userRoleService: UserRoleService,
        public _jobService: JobService,
    ) { }

    ngOnInit() {
        // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        // if (this.userRole && this.userRole.isLearner) {
        //     this.isReadOnly = true
        //     console.log("level three value check form =>", this.userRole, this.isReadOnly)
        // } else {
        //     this.isReadOnly = false
        // }
        // let roleUser = []
        // if (this.currentUser != undefined) {
        //     console.log("this.currentUser------>  ", this.currentUser);
        //     roleUser.push(this.currentUser)
        //     let getRole = _.intersectionBy(this.jobData.instructors, roleUser, '_id');
        //     console.log("test-------------???", getRole);
        //     if (getRole && getRole.length) {
        //         if (getRole[0].role == 'IQA') {
        //             console.log("user is IQA ");
        //             this.isIQA = true
        //         } else {
        //             this.isTrainer = true
        //         }
        //     }
        //  else {
        // this.isTrainer = true
        // }
        // }
        this.createForm()
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log("changes in info n contact", changes)
        if (changes.singleJob && changes.singleJob.currentValue) {
            this.jobData = changes.singleJob.currentValue[0]
            this.getUserRole();
        }

        if (changes.job && changes.job.currentValue) {
            this.currentJob = changes.job.currentValue
            console.log("current role",this.currentJob);
            
        }

        if (changes.learnerObj && changes.learnerObj.currentValue) {
            this.learnerObj = changes.learnerObj.currentValue
            this.createForm()
        }

        if (changes.infoNcontactEdit && changes.infoNcontactEdit.currentValue) {
            this.infoEdit = changes.infoNcontactEdit.currentValue
            console.log('changes.infoNcontactEdit.currentValue', changes.infoNcontactEdit.currentValue)
            this.createForm()
        }
        if (changes.layout && changes.layout.currentValue) {
            this.isLayout = changes.layout.currentValue
            console.log("layout data check =>", this.isLayout)
        }
        if (changes.level3 && changes.level3.currentValue) {
            this.isLevel3 = changes.level3.currentValue
            console.log("level three value check form =>", this.isLevel3)
            this.createForm()

        }

        if (changes.courseComponent && changes.courseComponent.currentValue) {
            let value = changes.courseComponent.currentValue
            console.log('value here .....................', value)
            this.iscourseName = changes.courseComponent.currentValue;
        }
    }
    getUserRole(){
        console.log("this.this.jobData............",this.jobData);
        
        let getRole = this._userRoleService.getUserRole(this.jobData.instructors,'job');
        if (getRole.isAdmin) this.isAdmin = true
        else if(getRole.isLearner) this.isLearner = true
        else if(getRole.isTrainer) this.isTrainer = true
        else if(getRole.isIQA) this.isIQA = true
    
      }

    // if(this.isle){}
    createForm() {
        if (this.level3 == true) {
            console.log("level 3 active", this.infoEdit)

            this.infoForm = new FormGroup({
                address: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.address : ''),
                candidateName: new FormControl(this.learnerObj && this.learnerObj.name ? this.learnerObj.name : ''),
                // candidateRegNo: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.candidateRegNo : ''),
                assessorName: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.assessorName : ''),
                IQAName: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.IQAName : ''),
                ContactForCandidate: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.ContactForCandidate : ''),
                EmailForCandidate: new FormControl(this.learnerObj && this.learnerObj.name ? this.learnerObj.email : ''),
                ContactForAssessor: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.ContactForAssessor : ''),
                EmailForAssessor: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.EmailForAssessor : '', Validators.email),
                EQAName: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.EQAName : '')
            })

        }
        else {
            this.infoForm = new FormGroup({
                address: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.address : ''),
                candidateName: new FormControl(this.learnerObj && this.learnerObj.name ? this.learnerObj.name : ''),
                candidateRegNo: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.candidateRegNo : ''),
                assessorName: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.assessorName : ''),
                IQAName: new FormControl((this.infoEdit && this.infoEdit.infoNContact) ? this.infoEdit.infoNContact.IQAName : ''),
            })
        }

    }


    // Utility
    handleSnackBar(data) {
        this.openSnackBar(data.msg, data.button);
    }
    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 2000,
        });
    }

    checkLevel2Policy(policy) {
        let temp = this.iscourseName.includes(policy)
        if (temp) {
            return false
        } else {
            return true
        }
    }


    submitInfo() {
        console.log("this.infoForm.values", this.infoForm.value)
        if (this.infoForm.valid) {
            this.loading = true
            let data = {
                learnerId: this.learnerObj._id,
                jobId: this.currentJob,
                version: true,
                details: {
                    infoNContact: this.infoForm.value,
                }
            }
            console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
            this._learnerService.submitPolicy(data).subscribe(res => {
                console.log('Policy res', res);
                this.handleSnackBar({ msg: "Data submitted successfully", button: "Ok" });
                this.loading = false
            }, (err) => {
                this.loading = false
                console.log("policy not accepted", err)
            })
        } else {
            this.infoForm.markAllAsTouched();
            return;
        }
    }
}
